import { Field } from 'formik';
import type { FieldProps } from 'formik';

import { Select } from '@frontend/legacy-components';

import { HorizontalFormControl } from 'components/listTablePage';

import { PaymentStatus as PaymentStatusType, PAYMENT_STATUSES } from './types';
import type { OrdersListFiltersFormData } from './types';

const PAYMENT_STATUS_TO_OPTION_MAP: {
  [T in PaymentStatusType]: { label: string; value: T };
} = {
  [PAYMENT_STATUSES.ALL]: {
    label: 'All',
    value: PAYMENT_STATUSES.ALL,
  },
  [PAYMENT_STATUSES.PO]: {
    label: 'PO',
    value: PAYMENT_STATUSES.PO,
  },
  [PAYMENT_STATUSES.CREDIT_CARD]: {
    label: 'Credit Card',
    value: PAYMENT_STATUSES.CREDIT_CARD,
  },
};

export const PaymentStatusFilter = () => {
  return (
    <HorizontalFormControl label="Payment Status">
      <Field name="paymentStatus">
        {({
          field,
          form,
        }: FieldProps<
          OrdersListFiltersFormData['paymentStatus'],
          OrdersListFiltersFormData
        >) => (
          <Select
            options={Object.values(PAYMENT_STATUS_TO_OPTION_MAP)}
            onChange={(status: { label: string; value: string } | null) => {
              status
                ? form.setFieldValue(field.name, status.value)
                : form.setFieldValue(field.name, PAYMENT_STATUSES.ALL);
            }}
            value={PAYMENT_STATUS_TO_OPTION_MAP[field.value ?? '']}
          />
        )}
      </Field>
    </HorizontalFormControl>
  );
};
